import { EventsService } from "api/services/events";
import { RecurringUpdateOptions } from "containers/events/EventsAdminContainer/domain";
import { EventRegistrationTypes } from "containers/events/EventsAdminContainer/EditEventContainer/domain";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { setlocalStorageValue } from "utils/localStorage";
import miscUtils from "utils/miscUtils";

export function isPastEvent(event: any) {
  const todayDateString = moment().utc().format("YYYY-MM-DD HH:mm:ss");
  const endDateString = moment(event.end_time).format("YYYY-MM-DD HH:mm:ss");
  return(moment(endDateString).isBefore(todayDateString));
}

  const showRecurringEventRSVPOptions = (event: any) => {
    return (
      event &&
      event.is_recurring && 
      event.recurring_config
      // !(
      //   event.access === "priced"
      //   event.price &&
      //   event.price.type === "series"
      // )
    )
  }

export function rsvpEvent(
    groupData: any, 
    event: any, 
    user: any, 
    userId: any,
    history: any,
    setIsLockScreenPopUpOpen: any,
    onRSVPSuccess: any,
    options?: any,
    data?: any
) {
    const checkOnRedirect = () => {
      if(
        options &&
        options.onRedirect
      ) {
        options.onRedirect();
      }
    }

    const shouldDisplayRSVPOptions = () => {
      if(
          options &&
          options.editRecurringEventRef &&
          options.setIsEditRecurringEventModalOpen &&
          showRecurringEventRSVPOptions(event) && 
          !data
        ) {
            options.editRecurringEventRef.current = {
              callback: (recurringUpdateOption: RecurringUpdateOptions) => rsvpEvent(
                groupData,
                event,
                user,
                userId,
                history,
                setIsLockScreenPopUpOpen,
                onRSVPSuccess,
                options,
                {
                  rsvp_option: recurringUpdateOption,
                  user_time: miscUtils.getDateInGivenTimezone("Etc/GMT", new Date()).format("YYYY-MM-DD HH:mm:ss"),
                }
              ),
              title: 'Recurring event RSVP',
              buttonLabel: 'RSVP',
            }
            options.setIsEditRecurringEventModalOpen(true);
            return true;
          }

          return false;
    }

    if(
      options &&
      options.forceOverride
    ) {
      if(shouldDisplayRSVPOptions()) {
        return;
      }
      requestRsvp(
          event,
          user,
          onRSVPSuccess,
          options,
          data
      );
      return;
    }

    if(
      event.closed 
      // &&
      // !miscUtils.isTeamMember(groupData && groupData.user_membership)
    ) {
      toast('This event is closed', {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }

    if(
      event.max_capacity &&
      event.rsvps_count &&
      event.rsvps_count >= event.max_capacity 
      // &&
      // !miscUtils.isTeamMember(groupData && groupData.user_membership)
    ) {
      toast('This event is now full.', {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }

    if (groupData && !miscUtils.isActiveCommunityMember(groupData.user_membership)) {
      if (
        event &&
        event.access === "free" &&
        event.visibility === "public" &&
        userId &&
        !event.rsvp || (event.rsvp && event.rsvp.deleted_at)
      ) {
        if(shouldDisplayRSVPOptions()) {
          return;
        }
        requestRsvp(
            event,
            user,
            onRSVPSuccess,
            options,
            data
        );
        return;
      }


      if (isPastEvent(event)) {
        window.location.href = "/plan-subscription";
        return;
      }

      if (event && event.access === "priced" && !event.rsvp) {
        checkOnRedirect();
        if(
          event &&
          event.price &&
          event.price.options &&
          event.price.options.length === 1
        ) {
          history.push(`/events/${event.slug}/purchase?payment_option=${event.price.options[0].slug}`);
          return;
        }
        history.push(`/events/${event.slug}/purchase`);
        return;
      }

      if (event.lock_screen_active && (!event.rsvp || (event.rsvp && event.rsvp.deleted_at))) {
        if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
          window.location.assign(event.lock_screen_default_url);
          return;
        }
        setIsLockScreenPopUpOpen(true);
        return;
      }

      if (
        event &&
        event.access === "plan" &&
        event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden).length === 1
      ) {
        const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden);
        checkOnRedirect();
        window.location.href = `/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`;
        return;
      }

      if (event && event.access === "plan") {
        if (
          event.authorized_plans &&
          event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
        ) {
          window.location.replace("/plan-disabled");
          return;
        }

        if (
          event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden).length === 1
        ) {
          const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden);
          checkOnRedirect();
          window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
          return;
        }

        if (
          event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
        ) {
          const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && plan.hidden);
          checkOnRedirect();
          window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
          return;
        }

        checkOnRedirect();
        window.location.href = `/plan-subscription?type=events&id=${event.slug}`;
        return;
      }

      if (
        event.access === "segment" &&
        (!event.rsvp || (event.rsvp && event.rsvp.deleted_at))
      ) {
        if (!event.lock_screen_active) {
          toast("You do not have permission to RSVP for this event", {
            type: 'error',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
        } else {
          if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
            window.location.assign(event.lock_screen_default_url);
            return;
          }
          setIsLockScreenPopUpOpen(true);
        }
        return;
      }

      if (event && event.access === "paid" ) {
        if (event.lock_screen_active) {
          if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
            window.location.assign(event.lock_screen_default_url);
            return;
          }
          setIsLockScreenPopUpOpen(true);
          return;
        }

        checkOnRedirect();
        window.location.href = "/plan-subscription";
        return;
      }
    } else {
      if (
        event.access === "segment" &&
        !miscUtils.isTeamMember(groupData && groupData.user_membership) &&
        !miscUtils.userIsOnResourseSegment(groupData && groupData.user_membership, event.authorized_segments) &&
        (!event.rsvp || (event.rsvp && event.rsvp.deleted_at))
      ) {
        if (!event.lock_screen_active) {
          toast("You do not have permission to RSVP for this event", {
            type: 'error',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
        } else {
          if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
            window.location.assign(event.lock_screen_default_url);
            return;
          }
          setIsLockScreenPopUpOpen(true);
        }
        return;
      }

      if (
        event.access === "plan" &&
        !miscUtils.isTeamMember(groupData && groupData.user_membership) &&
        !miscUtils.userIsOnResourcePlan(groupData && groupData.user_membership, event.authorized_plans) &&
        (!event.rsvp || (event.rsvp && event.rsvp.deleted_at)) 
      ) {
        if (!event.lock_screen_active) {
          if (
            event.authorized_plans &&
            event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
          ) {
            window.location.replace("/plan-disabled");
            return;
          }

          if (
            event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden).length === 1
          ) {
            const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden)
            checkOnRedirect();
            window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
            return;
          }

          if (
            event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
          ) {
            const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && plan.hidden)
            checkOnRedirect();
            window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
            return;
          }

          checkOnRedirect();
          window.location.href = `/plan-subscription?type=events&id=${event.slug}`;
        } else {
          if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
            window.location.assign(event.lock_screen_default_url);
            return;
          }
          setIsLockScreenPopUpOpen(true);
        }
        return;
      }

      if (!miscUtils.isTeamMember(groupData && groupData.user_membership)) {
        const userPlan = miscUtils.getUserPlan(groupData && groupData.user_membership);

        if (event && event.access === "paid" && (
          userPlan.name === "free" || userPlan.price === 0)) {
          if (event.lock_screen_active) {
            if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
              window.location.assign(event.lock_screen_default_url);
              return;
            }
            setIsLockScreenPopUpOpen(true);
            return;
          }

          checkOnRedirect();
          window.location.href = "/plan-subscription";
          return;
        }

        if (event && event.access === "priced" && (!event.rsvp) ) {
          if(
            event &&
            event.price &&
            event.price.options &&
            event.price.options.length === 1
          ) {

            checkOnRedirect();
            history.push(`/events/${event.slug}/purchase?payment_option=${event.price.options[0].slug}`);
            return;
          }

          checkOnRedirect();
          history.push(`/events/${event.slug}/purchase`);
          return;
        }

        if (
          event && event.access === "plan" && 
          !miscUtils.userIsOnResourcePlan(groupData && groupData.user_membership, event.authorized_plans)
        ) {
          if (
            event.authorized_plans &&
            event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
          ) {
            window.location.replace("/plan-disabled");
            return;
          }

          if (
            event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden).length === 1
          ) {
            const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden);
            checkOnRedirect()
            window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
            return;
          }

          if (
            event.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
          ) {
            const eventPlans = event.authorized_plans.filter((plan: any) => !plan.archived_at && plan.hidden);
            checkOnRedirect();
            window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=events&id=${event.slug}`);
            return;
          }

          const filterPlans = event.authorized_plans.filter((plan: any, index: any) => plan.id === userPlan.id);

          if (filterPlans.length <= 0) {
            if (event.lock_screen_active) {
              if (event.lock_screen_default_url && event.lock_screen_type === 'redirect') {
                window.location.assign(event.lock_screen_default_url);
                return;
              }
              setIsLockScreenPopUpOpen(true);
              return;
            }

            if (
              event.authorized_plans.length === 1
            ) {
              checkOnRedirect();
              window.location.href = `/plan-subscription/checkout?plan=${event.authorized_plans[0].uuid}&type=events&id=${event.slug}`;
              return;
            }

            checkOnRedirect();
            window.location.href = `/plan-subscription?type=events&id=${event.slug}`;
            return;
          }
        }
      }
    }

    if(
      event.registration_type === EventRegistrationTypes.External &&
      event.registration_url
    ) {
      window.open(event.registration_url, '_blank');
      return;
    }


    if(user && shouldDisplayRSVPOptions()) {
        return;
    }
    
    requestRsvp(
        event,
        user,
        onRSVPSuccess,
        options,
        data
    );
  }

const requestRsvp = (
    event: any,
    user: any,
    onRSVPSuccess: any,
    options?: any,
    data?: any,
) => {
    if (!user) {
      setlocalStorageValue("next_link", window.location.pathname);
      window.location.href = `/plan-subscription?to=/events/${event.slug}`
      return;
    }

    if (isPastEvent(event)) {
      toast("This event is no longer active", {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }

    EventsService.getInstance()
      .rsvpEvent(event.id, data)
      .then((response: any) => {
        toast("You have RSVPed to this event successfully", {
          type: 'success',
          autoClose: 2000,

          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });

        const _event = response.data;
        _event.authorized_plans = event.authorized_plans;
        _event.price = event.price;
        onRSVPSuccess(response.data);
      })
      .catch((error: any) => {
        if(
          options &&
          options.setRestrictedCourseEventState &&

          error.status === 403 &&
          error.data &&
          error.data.errors &&
          error.data.errors.course_title &&
          error.data.errors.course_url
        ) {
          options.setRestrictedCourseEventState({
            isOpen: true,
            courseTitle: error.data.errors.course_title,
            courseUrl: error.data.errors.course_url,
          });
        }
      })
  }

export function removeEventRsvp(
    event: any,
    userId: any,
    onRemoveRSVP: any,
    options?: any,
    data?: any,
) {

      if(
        options &&
        options.editRecurringEventRef &&
        options.setIsEditRecurringEventModalOpen &&
        showRecurringEventRSVPOptions(event) && 
        !data
      ) {
        options.editRecurringEventRef.current = {
          callback: (recurringUpdateOption: RecurringUpdateOptions) => removeEventRsvp(
            event,
            userId,
            onRemoveRSVP,
            options,
            {
              rsvp_option: recurringUpdateOption,
              user_time: miscUtils.getDateInGivenTimezone("Etc/GMT", new Date()).format("YYYY-MM-DD HH:mm:ss"),
            }
          ),
          title: 'Cancel recurring event RSVP',
          buttonLabel: 'Cancel RSVP',
        }
        options.setIsEditRecurringEventModalOpen(true);
        return;
      }

    if(isPastEvent(event)) {
      toast("This event is no longer active", {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }
    EventsService.getInstance()
      .removeEventRsvp(event.id, data)
      .then((response: any) => {
        toast("You have cancelled your RSVP to this event successfully", {
          type: 'success',
          autoClose: 2000,

          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });
        const _event = event;
        _event.rsvp = null;
        _event.rsvps = _event.rsvps.filter((attendee: any, index: any) => attendee.user_id !== userId);
        _event.rsvps_count = _event.rsvps_count - 1;

        onRemoveRSVP();
      }).catch((error: any) => console.error(error))
  }
